import "owl.carousel"

const navText = [
  '<i class="icon icon-angle-left">Poprzedni</i>',
  '<i class="icon icon-angle-right">Następny</i>',
]
const defaultOptions = {
  nav: false,
  loop: true,
  dots: false,
  autoplay: true,
  autoplayTimeout: 4000,
  // autoWidth: true,
  autoplayHoverPause: true,
  navText: navText,
  onInitialized: function() {
    $(".show-bigger").magnificPopup({
      type: "image",
      titleSrc: "title",
      gallery: { enabled: true },
      // other options
    })
  },
}

export const setupCarousel = (selector, options = {}) => {
  const newOptions = Object.assign({}, defaultOptions, options)
  $(selector).owlCarousel(newOptions)
}

export const optionsWithNav = {
  responsive: {
    0: { items: 1 },
    690: { items: 1 },
    768: { items: 2 },
    992: { items: 3 },
  },
  dots: false,
  dotsData: true,
  loop: false,
  autoplay: false,
  autoplayTimeout: 4000,
  nav: true,
  navText: navText,
}
